<template>
  <div>
    <div
      v-if="openWysi == 'new'"
      class="is-border has-background-white">
      <contact-note
        :source="{message: ''}"
        @deleteNote="deleteNote"
        @close="noteClose"
        @save="noteSave"></contact-note>
    </div>

    <div
      v-if="notes && notes.length"
      class="has-background-white is-padding is-border-left is-border-right">
      <div
        v-for="(note) in notes"
        :key="note.pk"
        class="vadDiscussion">
        <div
          v-if="note.pk !== openWysi"
          class="vadDiscussion--bulle is-size-6"
          :class="{'is-classic': note.user.pk != currentUser.pk}">
          <div
            class="content is-break-word"
            v-html="note.message"></div>
        </div>
        <contact-note
          v-else
          @deleteNote="deleteNote"
          :source="note"
          @close="noteClose"
          @save="noteSave"
          class="is-border"></contact-note>
        <div class="level">
          <div class="level-left">
            <div class="is-size-7">
              <div><b>Date : </b>{{ note.created_on | prettyDatetime }}</div><!-- prettyDate -->
              <div><b>Auteur : </b>{{ note.user.last_name }} {{ note.user.first_name }}</div>
            </div>
          </div>
          <div class="level-right">
            <button
              v-if="note.user.pk == currentUser.pk"
              type="submit"
              @click="openWysi = note.pk"
              class="button is-white is-border is-rounded is-xsmall"
              :disabled="openWysi !== null">
              <span class="icon is-small"><i class="fas fa-marker"></i></span>
              <span>Modifier note</span>
            </button><!-- @click="openNoteQuickview({ item: Object.assign({}, note) })" -->
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!notes.length && openWysi === null"
      class="has-background-white is-padding-right is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall is-border-left is-border-top is-border-right">
      <span class="is-size-6"><i>Aucune note de suivi</i></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NotesList',
  components: {
    ContactNote: () => import('../contacts/ContactRightPanel/ContactNote')
  },
  props: {
    source: {
      type: String
    }
  },
  data () {
    return {
      openWysi: null, // PK du commentaire à ouvrir ou 'new' pour un nouveau commentaire
      notes: []
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created () {
    this.getNotes()
  },
  methods: {
    openWysiMeth () {
      this.openWysi = 'new'
    },
    async getNotes () {
      try {
        let { data } = await this.$api.get(`/reservations/${this.source}/notes`)
        this.notes = data.items
      } catch (err) {
        console.log(err)
      }
    },
    async deleteNote (note) {
      try {
        await this.$api.delete(`/reservations/${this.source}/notes`, note.pk)
        this.getNotes()
        this.noteClose()
      } catch (err) {
        console.log(err)
      }
    },
    noteSave (note) {
      if ('pk' in note && note.pk) {
        this.editNote(note)
      } else {
        this.createNote(note)
      }
      this.noteClose()
    },
    async editNote (note) {
      try {
        await this.$api.put(`/reservations/${this.source}/notes`, note.pk, note)
        this.getNotes()
      } catch (err) {
        console.log(err)
      }
    },
    async createNote (note) {
      try {
        await this.$api.post(`/reservations/${this.source}/notes`, note)
        this.getNotes()
      } catch (err) {
        console.log(err)
      }
    },
    toggleNotes () {
      this.viewAllNotes = !this.viewAllNotes
    },
    noteClose () {
      this.openWysi = null
    }
  }
}
</script>
